import type { IconGlyph } from '../icon';

/**
 * Tractie `home-thick` glyph (medium, 24×24), shown on the current nav item.
 *
 * Source: `@tractie/icons` v1.5.0, `dist/jsx/m/home-thick.jsx`.
 * Verbatim copy of the SVG `d` attribute.
 */
export const iconHomeThick: IconGlyph = {
  name: 'home-thick',
  path: 'M20.64 10.23 12 3.03l-8.64 7.2c-.42.35-.48.98-.13 1.41.35.42.98.48 1.41.13l.36-.3v7.03c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-7.03l.36.3c.42.35 1.05.3 1.41-.13s.3-1.05-.13-1.41M13 18h-2v-3h2zm4 0h-2v-3.5c0-.83-.67-1.5-1.5-1.5h-3c-.83 0-1.5.67-1.5 1.5V18H7V9.8l5-4.17 5 4.17z',
};
